import {FC, memo } from 'react';

const BookmarkIcon24Fill: FC<{ fill: string}> = ({ fill }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 21V6.17647C5 4.42215 6.34315 3 8 3H16C17.6569 3 19 4.42215 19 6.17647V21L12 14.262L5 21Z" fill="#FEFEFE"/>
        <path d="M5 21V6.17647C5 4.42215 6.34315 3 8 3H16C17.6569 3 19 4.42215 19 6.17647V21L12 14.262L5 21Z" stroke="#FEFEFE"/>
    </svg>
  );
}

export default memo(BookmarkIcon24Fill);
import {FC, memo } from 'react';

const BookmarkIcon24Fill: FC<{ fill: string}> = ({ fill }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 21V6.17647C5 4.42215 6.34315 3 8 3H16C17.6569 3 19 4.42215 19 6.17647V21L12 14.262L5 21Z" fill="#FEFEFE"/>
        <path d="M5 21V6.17647C5 4.42215 6.34315 3 8 3H16C17.6569 3 19 4.42215 19 6.17647V21L12 14.262L5 21Z" stroke="#FEFEFE"/>
    </svg>
  );
}

export default memo(BookmarkIcon24Fill);
